<template>
  <div id="J_chartCircleBox" class="chart-box"></div>
</template>

<script>

import {getOrderanalysisspu} from "@/request/requests";
import {MessageError,isEmpty} from "@/util/util"

export default {
  name: "circlePieChart",
  data(){
    return{
      chartCircle: null,
      screenWidth:null,
    }
  },
  methods:{
    getData(timeList){
      return new Promise((resolve)=>{
        let starttime = this.$moment(timeList[0]).format('yyyy-MM-DD');
        let endtime = this.$moment(timeList[1]).format('yyyy-MM-DD');
        console.log('获得环形图getData！')
        console.log(starttime);
        console.log(endtime);

        let dataList = [];
        let paramsData = {
          starttime,
          endtime
        };
        getOrderanalysisspu(paramsData).then(res=>{
          if(res.status=='200'){
            let list = res.data;
            if(!isEmpty(list)){
              list.forEach((item,i)=>{
                dataList.push({
                  value: item.data,
                  name: item.goodsname
                })
              })
            }
            this.initPieCicle(dataList);
            resolve();
          }
        })
      })
    },
    initPieCicle(dataList) {
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            var title = `Activity`;
            var content = `${params.name}: ${params.value}`;
            return '<div>' + title + '</div>'
                + '<div style="color: #fff;">' + content + '</div>';
          }
        },
        legend: {
          //top: '5%',
          left: 'center'
        },
        grid:{
          top:'50%',//距上边距

        },
        // graphic: {
        //   type: 'text',
        //   left: 'center',
        //   top: 'center',
        //   style: {
        //     text: 'ECharts\n环形图', // 中间显示的文本，可以换行
        //     textAlign: 'center',
        //     fill: '#000', // 文本颜色
        //     fontSize: 14,
        //     fontWeight: 'bold'
        //     // 其他样式...
        //   }
        // },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['50%','70%'],
                //this.screenWidth<=576.98?['60','80']:['50%','70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              show: false,
              position: 'center'
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: 40,
            //     fontWeight: 'bold'
            //   }
            // },
            labelLine: {
              show: false
            },
            data: dataList
          }
        ]
      };
      this.chartCircle = this.$echarts.init(document.getElementById('J_chartCircleBox'))
      this.chartCircle.setOption(option);
      window.addEventListener('resize', () => {
        this.chartCircle.resize()
      })
    },
    calcWidth(){
      this.screenWidth = window.screen.width;
    }
  },
  mounted(){
    this.calcWidth();
    window.addEventListener("resize", this.calcWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>

</style>